export const CREATING = 'CREATING';
export const OVERDUE = 'OVERDUE';
export const PAID_IN_FULL = 'PAID_IN_FULL';
export const PARTIALLY_PAID = 'PARTIALLY_PAID';
export const CURRENT = 'CURRENT';
export const ERROR = 'ERROR';
export const QBO_ERROR = 'ERROR';
